import { Typography } from '@mui/material';

export const FooterView = (props) => {

    return (
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
      >
        <a href={props.org.footer_link} target='_blank' style={{textDecoration: 'none', color: '#0009'}}>{props.org.footer}</a>
      </Typography>
    );
};
